import {
  createContext,
  Dispatch,
  FC,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";

import { toast } from "react-toastify";
import { getAllOrganizations } from "../../../api/broker";
import { useAuthContext } from "../../../hooks/Auth";
import { iDataOrganizacion } from "../../../interfaces/SuperAdmin/Pages/iDataOrganizacion";

interface MainDashboardLayoutContextProps {
  orgs: iDataOrganizacion[];
  selectedOrg: string | undefined;
  isLoadingOrgs: boolean;
  handleChange: (selectedOrg: string, route: string) => Promise<void>;
  setSelectedOrg: Dispatch<SetStateAction<string | undefined>>;
}

const MainDashboardLayoutContext =
  createContext<MainDashboardLayoutContextProps>(
    {} as MainDashboardLayoutContextProps
  );

interface Props {
  children: React.ReactNode;
}

const MainDashboardLayoutProvider: FC<Props> = ({ children }) => {
  const { idOrganization } = useParams();
  const { canAccess } = useAuthContext();

  const [orgs, setOrgs] = useState<iDataOrganizacion[]>([]);
  const [selectedOrg, setSelectedOrg] = useState<string | undefined>(
    idOrganization
  );

  const [isLoadingOrgs, setIsLoadingOrgs] = useState(false);

  const navigate = useNavigate();

  // Fetch de organizaciones para seleccionar
  const fetchOrgs = async () => {
    setIsLoadingOrgs(true);
    try {
      const orgRes = await getAllOrganizations();

      if (orgRes.data.statusCode === 200) {
        setOrgs(orgRes.data.body);
      } else {
        toast.error("Error al obtener las organizaciones");
      }
    } catch (error) {
      console.log(error);
      toast.error("Error al obtener las organizaciones");
    } finally {
      setIsLoadingOrgs(false);
    }
  };

  // Solo hacemos el fetch de organizacion si somos Admin de Dominio
  useEffect(() => {
    const isSuperAdmin = canAccess("view:dashboard");
    if (isSuperAdmin) fetchOrgs();
  }, []);

  // Funcion para cambiar de organización
  const handleChange = async (selectedOrg: string, route: string) => {
    setSelectedOrg(selectedOrg);
    navigate(`/asistente/dashboard/${route}`);
  };

  return (
    <MainDashboardLayoutContext.Provider
      value={{
        orgs,
        selectedOrg,
        isLoadingOrgs,
        handleChange,
        setSelectedOrg,
      }}
    >
      {children}
    </MainDashboardLayoutContext.Provider>
  );
};

const useMainDashboardLayoutContext = () =>
  useContext(MainDashboardLayoutContext);

export { MainDashboardLayoutProvider, useMainDashboardLayoutContext };

